<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="postData"
      label-position="right"
      label-width="130px"
      class="form"
    >
      <el-form-item label="课次券名称" prop="card_ticket_type_name">
        <el-input
          v-model="postData.card_ticket_type_name"
          maxlength="20"
          show-word-limit
          clearable
          placeholder="请输入课次券名称"
        />
      </el-form-item>

      <el-form-item label="商品标题" prop="title">
        <el-input
          v-model="postData.title"
          maxlength="60"
          show-word-limit
          clearable
          placeholder="请输入课次券购买页的商品标题"
        />
      </el-form-item>

      <el-form-item label="课次券原价" prop="price_original">
        <v-input-money
          class="w100"
          placeholder="请输入课次券原价"
          :is-show-suffix="true"
          v-model="postData.price_original"
        />
        <el-alert
          title="仅做折扣展示使用，需设置高于实际价格的数额"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item label="课次券实际价格" prop="price">
        <v-input-money
          class="w100"
          placeholder="请输入课次券实际价格"
          :is-show-suffix="true"
          v-model="postData.price"
        />
        <el-alert
          title="用户购买课次券需要实际支付的价格"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item
        label="有效天数"
        prop="expire_days"
      >
        <v-input-money
          class="w100"
          placeholder="请输入课次券有效天数"
          :is-show-suffix="true"
          suffix-name="天"
          v-model="postData.expire_days"
          :min="0"
          :max="1098"
        />
        <el-alert
          title="用户获得优惠券后系统将根据有效天数设置过期时间"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>
      <el-form-item
        label="有效次数"
        prop="expire_number"
      >
        <v-input-money
          class="w100"
          placeholder="请输入课次券有效次数"
          :is-show-suffix="true"
          suffix-name="次"
          v-model="postData.expire_number"
          :min="0"
          :max="300"
        />
        <el-alert
          title="每次预约课程后次数将递减，为 0 时不可继续使用"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item label="购买范围" class="purchase-scope">
        <el-select
          class="w100"
          v-model="postData.purchase_scope"
          placeholder="不限制（默认）"
          clearable
        >
          <el-option
            v-for="scope in cardTicketPurchaseScopeOptions"
            :key="scope.value"
            :value="scope.value"
            :label="scope.name"
          />
        </el-select>
        <v-purchase-scope-rules :scope="postData.purchase_scope"/>
      </el-form-item>

      <el-form-item label="每人限持一张">
        <el-switch v-model="postData.is_only_one" :active-value="1" :inactive-value="0"/>

        <el-alert
          title="开启后，每个学员名下最多持有 1 张该类型课次券：小程序购买、后台直接办理与办券申请均受限；退券或删除后可再次获得。"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item label="小程序展示范围" class="app-show-scope">
        <el-radio-group v-model="appBuyScope">
          <el-radio :label="0">不展示</el-radio>
          <el-radio :label="1">开发版或体验版</el-radio>
          <el-radio :label="2">全部版本</el-radio>
        </el-radio-group>

        <el-alert
          title="「开发版或体验版」仅在开发版、体验版小程序可见可买，正式版看不到也无法下单，适合上线前内部测试；「全部版本」则开发版、体验版、正式版都可见可买。"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item label="课卡地区">
        <el-radio v-model="isGenericStoreCards" :label="1">全国通用</el-radio>
        <el-radio v-model="isGenericStoreCards" :label="0">外地课卡</el-radio>
      </el-form-item>

      <el-form-item label="绑定课卡" prop="card_charge_type_id">
        <v-cascader-card-type
          v-model="cardTypeInfo"
          :is-new="true"
          :store-ids="isGenericStoreCards ? [] : this.otherStoreIds"
          @change="handleCardTypeChange"
        />

        <el-alert
          title="绑定课卡后，学员在办理或购买课次券时，名下必须有相应的课卡才可进行办理"
          type="warning"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item label="开卡时不自动开券">
        <el-switch v-model="postData.is_not_auto_start" :active-value="1" :inactive-value="0"/>

        <el-alert
          title="此功能默认关闭，若已绑定课卡，课次券默认在开卡时自动开券；开启后，课次券则在初次签到课程时开券。无论此功能是否开启，课次券都是在课卡次数用尽后才会生效，即已开券但未生效的课次券仍无法使用。"
          type="warning"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item label="使用规则" prop="rule">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4 }"
          placeholder="请输入课次券的使用规则"
          v-model="postData.rule"
          maxlength="2000"
          show-word-limit
        />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">立即添加</el-button>
        <el-button @click="RouteConfig.cardChargeTypeList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { store } from '@/api/card-ticket-type';
import { toCent } from "@/filters";
import handleCardTypeChange from "@/utils/handleCardTypeChange";
import { cardTicketPurchaseScopeOptions } from '@/enums/cardTicketPurchaseScopes';

export default {
  name: RouteConfig.cardTicketTypeAdd.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    isPhoneSearching: false,
    isCardNumberSearching: false,
    cardTypeInfo: [],
    card: {},
    isGenericStoreCards: 1,
    otherStoreIds: [9,10,11,12,13,14,15,16,17,19,22,25,27,31],
    cardTicketPurchaseScopeOptions,
    postData: {
      card_ticket_type_name: '',
      title: '',
      expire_days: 0,
      expire_number: 0,
      price_original: 0,
      price: 0,
      rule: '',
      purchase_scope: '',
      is_only_one: 0,
      is_show_app: 0,
      is_test_only: 0,
      is_not_auto_start: 0,
      card_charge_type_id: 0,
      card_name: '',
    },
    pickerOptions: {
      disabledDate: (time) => time.getTime() < 0,
    },
    rules: {
      card_ticket_type_name: [{ required: true, message: '请输入课次券名称', trigger: 'change' }],
      price_original: [{ required: true, message: '请输入课次券原价', trigger: 'change' }],
      price: [{ required: true, message: '请输入课次券实际价格', trigger: 'change' }],
      title: [{ required: true, message: '请输入课次券购买页的商品标题', trigger: 'change' }],
      rule: [{ required: true, message: '请输入课次券使用规则', trigger: 'change' }],
    },
  }),
  computed: {
    // 小程序展示范围：0-不展示 1-开发版或体验版 2-全部版本；映射到 is_show_app / is_test_only 两个字段
    appBuyScope: {
      get() {
        if (this.postData.is_show_app) return 2;
        return this.postData.is_test_only ? 1 : 0;
      },
      set(scope) {
        this.postData.is_show_app = scope === 2 ? 1 : 0;
        this.postData.is_test_only = scope === 1 ? 1 : 0;
      },
    },
  },
  methods: {
    handleCardTypeChange(cardTypeInfo) {
      handleCardTypeChange(cardTypeInfo, this.card);
      this.postData.card_charge_type_id = this.card.card_charge_type_id;
      this.postData.card_name = `${this.card.card_type_name}/${this.card.card_name}`;
    },
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        const postData = { ...this.postData };
        const purchaseScope = postData.purchase_scope || 0;
        const { isError } = await store({
          card_ticket_type_name: postData.card_ticket_type_name,
          expire_days: toCent(postData.expire_days),
          expire_number: toCent(postData.expire_number),
          price_original: toCent(postData.price_original),
          price: toCent(postData.price),
          purchase_scope: purchaseScope,
          // 兼容旧接口：由 purchase_scope 派生
          is_new: purchaseScope === 1 ? 1 : 0,
          is_no_card_except_personal: purchaseScope === 3 ? 1 : 0,
          is_only_one: postData.is_only_one,
          title: postData.title,
          rule: postData.rule,
          is_show_app: postData.is_show_app,
          is_test_only: postData.is_test_only,
          is_not_auto_start: postData.is_not_auto_start,
          card_charge_type_id: postData.card_charge_type_id,
          card_name: postData.card_name,
        });
        this.isSaving = false;
        if (!isError) RouteConfig.cardTicketTypeList.push();
      });
    },
  },
};
</script>

<style scoped>
/* 多个选项保持一行、与左侧 label 水平对齐（禁止竖排，竖排会让 label 与内容错位）；
   提示条抵掉 Element .el-form-item__content 40px 固定行高给矮控件带来的多余空行 */
.app-show-scope .el-radio {
  margin-right: 20px;
}

.app-show-scope .el-alert {
  margin-top: 2px;
}
</style>

